export class Response{

    public nombre : any;
    public id : any;
    public type : any;
    public message : any;
    public confirma : any;
    public mensaje : any;
    
}